import { httpRequest } from "@/lib";
import { CreateTypeModelRequestDTO, ModelType, RequestModelTypeResponse } from "@/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

async function createTypeModel(
  request: CreateTypeModelRequestDTO
): Promise<ModelType> {
  const response = await httpRequest.post<RequestModelTypeResponse>("/models-types", request);
  return response.data.data;
}

export function useCreateTypeModelMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createTypeModel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["models-types"] });
      queryClient.invalidateQueries({ queryKey: ["models"] });
    },
  });
}
